export const uploadHandsColumnNames = [
	'aliasIndex',
	'handStatus',
	'date',
	'heroName',
	'effStack',
	'room',
	'spot',
	'heroCards',
	'villainCards',
	'heroPos',
	'unifiedBoard',
	'unifiedLine',
	'prLine',
	'flop',
	'fLine',
	'postflopType',
	'turn',
	'tLine',
	'river',
	'rLine',
	'summDPlayed',
	'summDEV',
	'id',
]

export const trainerHandsColumnNames = [
	'date',
	'effStack',
	'spot',
	'heroCards',
	'heroPos',
	'unifiedBoard',
	'unifiedLine',
	'prLine',
	'flop',
	'fLine',
	'postflopType',
	'turn',
	'tLine',
	'river',
	'rLine',
	'summDPlayed',
	'summDEV',
	'id',
]

export const uploadHandLineColumnNames = [
	'aliasIndex',
	'Date',
	'heroName',
	'effStack',
	'room',
	'spot',
	'hero_pos',
	'hero_cards',
	'pre_line',
	'Flop',
	'f_line',
	'turn',
	't_line',
	'river',
	'r_line',
	'hand_combo',
	'hand_draw',
	'player_actions',
	'gto_actions',
	'diff_played',
	'diff_ev',
	'queryLine',
	'id',
]

export const trainerHandLineColumnNames = [
	'Date',
	'effStack',
	'spot',
	'hero_pos',
	'hero_cards',
	'pre_line',
	'Flop',
	'f_line',
	'turn',
	't_line',
	'river',
	'r_line',
	'hand_combo',
	'hand_draw',
	'player_actions',
	'gto_actions',
	'diff_played',
	'diff_ev',
	'queryLine',
	'id',
]

export const uploadFilters = [
	'GameSpot',
	'Room',
	'Dates',
	'StreetMistakes',
	'StackBuyIn',
	'Line',
	'Player',
	'Hands&Error',
	'GroupMode',
	'Status',
]

export const trainerFilters = [
	'GameSpot',
	'Dates',
	'StreetMistakes',
	'StackBuyIn',
	'Line',
	'Player',
	'GameMode',
	'Hands&Error',
]

export const actions = ['Fold', 'Check', 'Bet', 'Call', 'Raise', 'All_In']
export const actionsAllIn = [false, false, false, false, false, true]

export const filtersStructure = {
	upload: {
		hands: [
			'sortedBy',
			'status',
			'filterEV',
			'gMinTimeStamp',
			'gMaxTimeStamp',
			'error_street',
			'stack',
			'buyIn',
			'line',
			'heroPos',
			'heroArray',
			'heroAliases',
			'handsCount',
			'villainArray',
			'villainAliases',
			'postflop_type',
			'room',
			'jobId',
		],
		replayer: [
			'sortedBy',
			'status',
			'filterEV',
			'gMinTimeStamp',
			'gMaxTimeStamp',
			'error_street',
			'stack',
			'buyIn',
			'line',
			'heroPos',
			'heroArray',
			'heroAliases',
			'handsCount',
			'villainArray',
			'villainAliases',
			'postflop_type',
			'room',
			'jobId',
		],
		handLine: [
			'sortedBy',
			'is_error',
			'is_hero',
			'gMinTimeStamp',
			'gMaxTimeStamp',
			'stack',
			'buyIn',
			'line',
			'heroPos',
			'villainPos',
			'heroArray',
			'heroAliases',
			'handsCount',
			'villainHandsCount',
			'villainArray',
			'villainAliases',
			'room',
			'jobId',
		],
		report: [
			'is_hero',
			'gMinTimeStamp',
			'gMaxTimeStamp',
			'stack',
			'buyIn',
			'heroPos',
			'villainPos',
			'heroArray',
			'heroAliases',
			'villainArray',
			'villainAliases',
			'handsCount',
			'villainHandsCount',
			'jobId',
		],
		handLineStats: [
			'sortedBy',
			'is_hero',
			'gMinTimeStamp',
			'gMaxTimeStamp',
			'line',
			'stack',
			'buyIn',
			'heroPos',
			'villainPos',
			'heroArray',
			'heroAliases',
			'villainArray',
			'villainAliases',
			'handsCount',
			'villainHandsCount',
			'touch_threashold',
			'is_mistake',
			'street',
			'room',
			'jobId',
		],
		handLineStatsForPlayers: [
			'sortedBy',
			'is_hero',
			'gMinTimeStamp',
			'gMaxTimeStamp',
			'stack',
			'buyIn',
			'line',
			'heroArray',
			'heroAliases',
			'villainArray',
			'villainAliases',
			'playersArray',
			'playersAliases',
			'heroPos',
			'villainPos',
			'playersPos',
			'handsCount',
			'villainHandsCount',
			'playersHandsCount',
			'touch_threashold',
			'is_mistake',
			'room',
			'jobId',
		],
		handMistakeStats: [
			'sortedBy',
			'is_hero',
			'gMinTimeStamp',
			'gMaxTimeStamp',
			'line',
			'stack',
			'buyIn',
			'heroArray',
			'heroAliases',
			'villainArray',
			'villainAliases',
			'playersArray',
			'playersAliases',
			'heroPos',
			'villainPos',
			'playersPos',
			'handsCount',
			'villainHandsCount',
			'playersHandsCount',
			'touch_threashold',
			'is_mistake',
			'postflop_type',
			'room',
			'jobId',
		],
	},
	trainer: {
		hands: [
			'sortedBy',
			'gMinTimeStamp',
			'gMaxTimeStamp',
			'error_street',
			'stack',
			'line',
			'handsCount',
			'heroPos',
			'postflop_type',
			'game_mode',
			'configuration_id',
			'session_id',
		],
		replayer: [
			'sortedBy',
			'gMinTimeStamp',
			'gMaxTimeStamp',
			'error_street',
			'stack',
			'line',
			'handsCount',
			'heroPos',
			'postflop_type',
			'game_mode',
			'configuration_id',
			'session_id',
		],
		handLine: [
			'sortedBy',
			'gMinTimeStamp',
			'gMaxTimeStamp',
			'stack',
			'line',
			'handsCount',
			'heroPos',
			'configuration_id',
			'session_id',
		],
		report: ['gMinTimeStamp', 'gMaxTimeStamp', 'stack', 'heroPos', 'handsCount', 'configuration_id', 'session_id'],
		handLineStats: [
			'sortedBy',
			'gMinTimeStamp',
			'gMaxTimeStamp',
			'line',
			'stack',
			'heroPos',
			'handsCount',
			'touch_threashold',
			'is_mistake',
			'street',
			'configuration_id',
			'session_id',
		],
	},
}

export const allowedAllButton = ['handLineStatsForPlayers', 'handMistakeStats']

export const supportedSpots = [101, 104, 105, 115]

export const widthDrawer = 550
export const widthSiderBlock = 600
export const maxScreenWidth = 2000
export const maxTableWidth = 1065
export const drawerPadding = 15

export const TODAY = 'Today'
export const WEEK_AGO = 'Week ago'
export const MONTH_AGO = 'Month ago'
export const YEAR_AGO = 'Year ago'

export const TABS = {
	HANDS: 'hands',
	REPORT: 'report',
	HAND_LINE_STATS: 'handLineStats',
	PLAYERS: 'Players',
	HAND_LINE: 'handLine',
	HAND_MISTAKE_STATS: 'handMistakeStats',
	HAND_LINE_STATS_FOR_PLAYERS: 'handLineStatsForPlayers',
	REPLAYER: 'replayer',
}
